<template>
  <nav
    class="play-breadcrumb"
    aria-label="breadcrumb"
  >
    <ol class="play-breadcrumb__list">
      <slot />
    </ol>
  </nav>
</template>

<script>
/**
 * PlayBreadcrumb — breadcrumb trail for the Play system.
 *
 * Token-driven (see src/styles/tokens.scss). Replaces bootstrap-vue's
 * <b-breadcrumb>. Holds <PlayBreadcrumbItem>s in an ordered list; the separator
 * is drawn via CSS between items.
 *
 * VUE3-MIGRATION: nothing Vue 2-specific — already Vue 3-safe.
 */
export default {
  name: 'PlayBreadcrumb',
}
</script>

<style lang="scss" scoped>
.play-breadcrumb {
  &__list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;
    font-family: var(--font-body);
    font-size: 14px;
  }
}
</style>
